import { render, staticRenderFns } from "./StockFifoOffers.vue?vue&type=template&id=fff27dcc&scoped=true&"
import script from "./StockFifoOffers.vue?vue&type=script&lang=js&"
export * from "./StockFifoOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff27dcc",
  null
  
)

export default component.exports